import { BaseSelectItem } from 'wbs-components-lib';

import { BetOutcomeResultTypesEnum } from '@shared/constants';
import { BetOutcomeModel } from '@shared/types';

export const getBetOutcomeResultTypeSelectItems = (): BaseSelectItem[] =>
  Object.values(BetOutcomeResultTypesEnum)
    .filter((type) => type !== BetOutcomeResultTypesEnum.PENDING)
    .map((type) => ({
      id: type,
      value: type,
    }));

export const getInitialBetOutcomesMapWithResults = (
  betEventOutcome: BetOutcomeModel[]
): Record<string, BetOutcomeResultTypesEnum> =>
  betEventOutcome.reduce((outcomesMap, outcome) => {
    const { id: outcomeId } = outcome;

    return { ...outcomesMap, [outcomeId]: BetOutcomeResultTypesEnum.NEGATIVE };
  }, {});

export const getIsResultTypesApplied = (betEventOutcomesMap: Record<string, BetOutcomeResultTypesEnum>) => {
  const isResultTypesApplied = Object.values(betEventOutcomesMap).every(
    (resultType) =>
      resultType === BetOutcomeResultTypesEnum.NEGATIVE || resultType === BetOutcomeResultTypesEnum.POSITIVE
  );

  return isResultTypesApplied;
};
